import { render, staticRenderFns } from "./InventoryBatchEdit.vue?vue&type=template&id=b16c8c6c&"
import script from "./InventoryBatchEdit.vue?vue&type=script&lang=ts&"
export * from "./InventoryBatchEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports